import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ContentSectionContainer = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  padding: 0 1rem 1rem;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 85vh;
  flex: 1;
  min-width: 0;
  order: 2;
`;

// export const ChatContainer = styled.div`
//   flex: 3;
//   min-width: 0; /* Prevents flex item from overflowing */
// `;

export const ContextPanel = styled.div`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 340px;
  min-width: 340px;
  height: 85vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  order: 3;
`;

export const LeftSidebarContainer = styled.div<{ $open: boolean }>`
  width: ${({ $open }) => ($open ? '300px' : '0')};
  min-width: ${({ $open }) => ($open ? '300px' : '0')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: translateX(${({ $open }) => ($open ? '0' : '-16px')});
  transition:
    width 0.22s ease,
    min-width 0.22s ease,
    opacity 0.2s ease,
    transform 0.22s ease;
  overflow: hidden;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  order: 1;
`;

export const RightSidebarContainer = styled.div<{ $open: boolean }>`
  width: ${({ $open }) => ($open ? '340px' : '0')};
  min-width: ${({ $open }) => ($open ? '340px' : '0')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: translateX(${({ $open }) => ($open ? '0' : '16px')});
  transition:
    width 0.22s ease,
    min-width 0.22s ease,
    opacity 0.2s ease,
    transform 0.22s ease;
  overflow: hidden;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  order: 3;
`;

export const SessionsSidebar = styled.div`
  width: 300px;
  min-width: 300px;
  height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  padding: 0.75rem;
`;

export const SessionsSidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`;

export const SessionsSidebarTitle = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const SessionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SessionDateGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const SessionDateGroupTitle = styled.div`
  margin-top: 0.2rem;
  padding: 0 0.2rem;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 600;
`;

export const SessionListItem = styled.button<{ $active: boolean }>`
  width: 100%;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  background: ${({ $active, theme }) =>
    $active ? `${theme.colors.primary}14` : theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  padding: 0.6rem 0.7rem;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => `${theme.colors.primary}0d`};
  }
`;

export const SessionListItemTitle = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SessionListItemDate = styled.div`
  margin-top: 0.2rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ChatTopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background};
`;

export const ToolsPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem 0.9rem 0.25rem;
`;

export const AskSessionToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background};
`;

export const SidebarToggleButton = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => `${theme.colors.primary}0d`};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ActiveDocuments = styled.div`
  width: 100%;
  min-height: 0; /* Allows flex child to shrink */
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevents content from forcing parent to grow */
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ActiveDocumentsList = styled.div<{ $expanded: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: ${({ $expanded }) => ($expanded ? '1rem' : '0.5rem')};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  margin-top: 0.5rem;
  max-height: ${({ $expanded }) => ($expanded ? '40vh' : 'auto')};
  overflow-y: ${({ $expanded }) => ($expanded ? 'auto' : 'visible')};
  min-height: 0; /* Allows flex child to shrink */
`;

export const ActiveDocumentsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ActiveDocumentsItemTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
`;

export const ActiveDocumentsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

export const DocumentCard = styled.div`
  margin: 0;
  padding: 10px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
`;

export const DocumentName = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DocumentMeta = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 5px;
  line-height: 1.4;
`;

export const DocumentStats = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 5px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ActiveDocumentsItemContent = styled.p`
  font-size: 1rem;
  font-weight: 400;
`;

export const ThreadSummary = styled.div`
  width: 100%;
  min-height: 0; /* Allows flex child to shrink */
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevents content from forcing parent to grow */
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ThreadSummaryHeader = styled.div`
  margin-bottom: 0.5rem;
`;

export const ThreadSummaryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const ThreadSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ThreadSummaryItemTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
`;

export const ThreadSummaryItemContent = styled.p`
  font-size: 1rem;
  font-weight: 400;
`;

export const KeyboardShortcuts = styled.div`
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin-top: 1.5rem;
`;

export const KeyboardShortcutsHeader = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const KeyboardShortcutsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ShortcutItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: background-color 0.2s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}0d`};
    border-radius: ${({ theme }) => theme.borderRadius.xs};
  }
`;

export const ShortcutDescription = styled.span`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex: 1;
`;

export const ShortcutKey = styled.kbd`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-family: 'Courier New', monospace;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 600;
  min-width: fit-content;
  margin-left: 0.5rem;
`;

export const FeatureInfo = styled.div`
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 1.5rem;
`;

export const FeatureInfoHeader = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FeatureInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.background};
`;

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  &:last-child {
    border-bottom: none;
  }
`;

export const FeatureTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FeatureDescription = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.4;
`;

export const PinnedMessages = styled.div`
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 1.5rem;
`;

export const PinnedMessagesHeader = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PinnedMessagesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.background};
  max-height: 200px;
  overflow-y: auto;
`;

export const PinnedMessageItem = styled.div`
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.75rem;
  line-height: 1.4;

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}0d`};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const PinnedMessagePreview = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0.25rem;
`;

export const PinnedMessageMeta = styled.div`
  font-size: 0.625rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SearchBar = styled.div`
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  gap: 0.5rem;
  align-items: center;
  background: ${({ theme }) => theme.colors.background};
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  font-size: 0.875rem;
`;

export const SearchMatchCount = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const SearchNavButton = styled.button<{ $disabled: boolean }>`
  padding: 0.5rem;
  background: ${({ $disabled, theme }) =>
    $disabled ? theme.colors.grays.gray1 : theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const SearchCloseButton = styled.button`
  padding: 0.5rem 1rem;
  background: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
`;

export const AddDocumentButtonWrapper = styled.div`
  margin-bottom: 0.5rem;
`;

export const AddDocumentButton = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 2px dashed ${({ theme }) => theme.colors.border.light};
  text-align: center;
  transition: all 0.2s ease;
  background-color: ${({ theme }) => theme.colors.background};
  margin-bottom: 0.5rem;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => `${theme.colors.primary}0d`};
  }
`;

export const AddDocumentText = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const AddMoreDocumentsText = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const DocumentCardClickable = styled(DocumentCard)`
  cursor: pointer;
`;

export const SynopsisText = styled.div<{ $expanded: boolean }>`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.disabled};
  margin-top: 8px;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  display: ${({ $expanded }) => ($expanded ? 'block' : '-webkit-box')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const SynopsisToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primary};
  margin-top: 4px;
  padding: 0;
  text-decoration: underline;
`;

export const DocumentAddedDate = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.disabled};
  margin-top: 5px;
`;

export const RemoveDocumentButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem;
  color: ${({ theme }) => theme.colors.text.disabled};
  transition: color 0.2s ease;
  line-height: 1;

  &:hover {
    color: ${({ theme }) => theme.colors.error};
  }
`;

export const LinkedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  font-size: 0.7rem;
  font-weight: 600;
  background: ${({ theme }) => `${theme.colors.primary}14`};
  color: ${({ theme }) => theme.colors.primary};
`;

export const ShortcutKeysContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;

export const ShortcutClickHint = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-left: 0.25rem;
`;

export const ExportButtonContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
`;

export const ExportButton = styled.button`
  flex: 1;
  padding: 0.5rem;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
  font-size: 0.875rem;
`;

export const ModalContent = styled.div`
  padding: 1rem;
`;

export const ModalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ModalSectionTitle = styled.h3`
  margin-bottom: 1rem;
`;

export const ModalShortcutRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ModalKbd = styled.kbd`
  padding: 0.25rem 0.5rem;
  background: ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
`;

export const ModalFeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
`;

export const TemplatesHeader = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NewTemplateButton = styled.button`
  padding: 0.5rem 1rem;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
`;

export const EmptyTemplatesMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TemplatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TemplateItem = styled.div`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TemplateInput = styled.input`
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  font-size: 0.875rem;
`;

export const TemplateTextarea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  font-size: 0.875rem;
  resize: vertical;
`;

export const TemplateActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const UseTemplateButton = styled.button`
  padding: 0.5rem 1rem;
  background: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
`;

export const DeleteTemplateButton = styled.button`
  padding: 0.5rem 1rem;
  background: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
`;

export const PdfViewerError = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.disabled};
`;

export const PdfViewerLayout = styled.div`
  display: flex;
  gap: 0;
  height: calc(90vh - 100px);
  min-height: 400px;
  max-height: 100%;
  overflow: hidden;
`;

export const PdfViewerMain = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
`;

export const PdfViewerCitationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;
  flex-shrink: 0;
  min-height: 0;
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background};
`;

export const PdfViewerCitationsPanel = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem 0;
`;

export const PdfViewerCitationsPanelTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.025em;
  padding: 0.5rem 0.75rem;
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.background};
  z-index: 1;
`;

export const PdfViewerCitationItem = styled.button<{ $color: string }>`
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  width: 100%;
  padding: 0.4rem 0.75rem;
  font-size: 0.75rem;
  text-align: left;
  border: none;
  border-left: 3px solid ${({ $color }) => $color};
  background: transparent;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &:not(:last-child) {
    margin-bottom: 0.25rem;
  }
`;

export const PdfViewerCitationRef = styled.span<{ $color: string }>`
  font-weight: 700;
  color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const PdfViewerCitationSnippet = styled.span`
  flex: 1;
  min-width: 0;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PdfViewerCitationPage = styled.span`
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-shrink: 0;
  margin-top: 0.15rem;
`;

// Persona Selection Modal Styles
export const PersonaModalContent = styled.div`
  padding: 1rem;
`;

export const PersonaCardGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  padding: 0.5rem 0;
`;

export const PersonaCard = styled.div<{ $selected: boolean }>`
  padding: 1rem;
  border: 2px solid
    ${({ $selected, theme }) =>
      $selected ? theme.colors.primary : theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ $selected, theme }) =>
    $selected ? `${theme.colors.primary}14` : theme.colors.background};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => `${theme.colors.primary}0d`};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const PersonaIcon = styled.div`
  font-size: 32px;
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const PersonaName = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 0.5rem;
`;

export const PersonaDescription = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;
  margin-bottom: 0.5rem;
`;

export const PersonaTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.5rem;
`;

export const PersonaTag = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background-color: ${({ theme }) => theme.colors.border.light};
  color: ${({ theme }) => theme.colors.text.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
`;

export const PersonaModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const PersonaSubmitButton = styled.button`
  padding: 0.5rem 1.5rem;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.primary};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.grays.gray1};
    cursor: not-allowed;
  }
`;

export const PersonaCancelButton = styled.button`
  padding: 0.5rem 1.5rem;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background: ${({ theme }) => `${theme.colors.primary}0d`};
  }
`;

export const PersonaLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
`;

export const PersonaErrorContainer = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.error};
`;

// New styled components for refactored Context Panel
export const ExpandToggleButton = styled.button`
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: all 0.2s ease;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}0d`};
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const UploadingIndicator = styled.div`
  padding: 0.75rem;
  background-color: ${({ theme }) => `${theme.colors.primary}14`};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const CompactDocumentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
  gap: 0.5rem;
  padding: 0.5rem 0;
`;

export const CompactDocumentIcon = styled.div<{ $linked: boolean }>`
  position: relative;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.background};
  border: 2px solid
    ${({ $linked, theme }) =>
      $linked ? theme.colors.primary : theme.colors.border.light};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => `${theme.colors.primary}14`};
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const DocumentIcon = styled.div`
  font-size: 1.5rem;
  text-align: center;
`;

export const CompactDocumentContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  width: 100%;
  height: 100%;
`;

export const CompactDocumentLabel = styled.span`
  font-size: 0.65rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
`;

export const LinkedIndicator = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 0.75rem;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;
